import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function ExamCommittee() {
    const members = [
        { sr: 1, name: 'Dr. Sahadeo Aher', role: 'Chairman (Principal)' },
        { sr: 2, name: 'Senior Faculty Member (Arts)', role: 'Coordinator' },
        { sr: 3, name: 'Senior Faculty Member (Science)', role: 'Member' },
        { sr: 4, name: 'Senior Faculty Member (CS)', role: 'Member' },
        { sr: 5, name: 'Administrative Staff', role: 'Member Secretary' },
    ];
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Examinations › Examination Committee</p>
                <h1>Examination Committee</h1>
                <p>Overseeing internal and external examination processes fairly and efficiently.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>Committee Members</h2>
                    <table className="data-table">
                        <thead><tr><th>Sr.</th><th>Name</th><th>Role</th></tr></thead>
                        <tbody>{members.map(m => <tr key={m.sr}><td>{m.sr}</td><td style={{ fontWeight: 600 }}>{m.name}</td><td>{m.role}</td></tr>)}</tbody>
                    </table>
                </div>
                <div className="info-card">
                    <h2>Functions</h2>
                    <ul>
                        <li>Conducting internal examinations as scheduled by Savitribai Phule Pune University.</li>
                        <li>Preparation and distribution of hall tickets and seat numbers.</li>
                        <li>Invigilation duty allotment and monitoring fair examination practices.</li>
                        <li>Handling unfair means (UFM) cases as per university guidelines.</li>
                        <li>Coordination with university for external examination schedules and result declaration.</li>
                    </ul>
                </div>
                <div className="info-card">
                    <h2>Useful External Links</h2>
                    <div className="ext-links">
                        <a href="https://exam.unipune.ac.in" target="_blank" rel="noreferrer" className="ext-link-chip">🔗 Exam Form Online (SPPU)</a>
                        <a href="https://results.unipune.ac.in" target="_blank" rel="noreferrer" className="ext-link-chip">📊 Results (SPPU)</a>
                        <a href="https://convocation.unipune.ac.in" target="_blank" rel="noreferrer" className="ext-link-chip">🎓 Convocation (SPPU)</a>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default ExamCommittee;
